const XLSX = require("xlsx");

const doSave = function(
  value,
  filename = "",
  blobType = "application/vnd.ms-excel",
  urlType = "data:attachment/xlsx"
) {
  const blob = new Blob(value, {
    type: blobType
  });
  const downloadUrl = (window.URL || window.webkitURL).createObjectURL(blob, {
    type: urlType
  });
  const a = document.createElement("a");

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
    return;
  }
  a.download = filename;
  a.href = downloadUrl;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
  }, 500);
};

const readAsBinaryString = function(file) {
  let reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = function(event) {
      try {
        let data = event.target.result;
        let workbook = XLSX.read(data, {
          type: "binary"
        });
        let arr = [];
        workbook.SheetNames.forEach(function(sheetName) {
          let XL_row_object = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName]
          );
          arr = arr.concat(XL_row_object);
        });
        resolve(arr);
      } catch (e) {
        console.log(e);
        reject(e);
      }
    };
    reader.readAsBinaryString(file);
  });
};

const readAsText = function(file) {
  let reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = function(event) {
      try {
        let csv = event.target.result.replace(/^\n+|\n+$/g, "");
        let lines = csv.split("\n");
        let arr = [];
        let headers = lines[0].split(",");
        for (let i = 1; i < lines.length; i++) {
          let obj = {};
          let currentline = lines[i].split(",");
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];
          }
          arr.push(obj);
        }
        resolve(arr);
      } catch (e) {
        console.log(e);
        reject(e);
      }
    };
    reader.readAsText(file);
  });
};
// 从响应头拿到文件名 => responseType arrayBuffer / blob
const getFileNameFromHeaders = headers => {
  const contentDisposition = headers["content-disposition"] || "filename=";
  return decodeURI(contentDisposition.match(/filename=(.*)/i)[1]);
};

export { doSave, readAsBinaryString, readAsText, getFileNameFromHeaders };
